import { animateStatisticsWhenVisible } from './utils.js';

$(function() {
    animateStatisticsWhenVisible('#numbers #empresas-activas');
    animateStatisticsWhenVisible('#numbers #trabajadores-registrados');
    animateStatisticsWhenVisible('#numbers #variacion-interanual');
});